import { convertMediaTrack } from './utils';
import { errorPlayerContainerNotCreated } from './errors';
export const playerSelectedSubtitlesTrack = (container) => {
    if (!container) {
        throw errorPlayerContainerNotCreated;
    }
    const player = container.getAny();
    return {
        selectedSubtitlesTrack: {
            track: player.selectedSubtitlesTrack ? convertMediaTrack(player.selectedSubtitlesTrack) : undefined,
        },
    };
};
